export const INSTALLATION = 'installation';
export const PRODUCT = 'product';
export const PRODUCT_DETAIL = 'product-detail';
export const PRODUCT_SELECT = 'product-select';
export const SELECT = 'select';
export const SELECT_OPTION = 'select-option';
